export const TOKEN_STORAGE_KEY = 'mafert_system_token';
